// routes/index.js
import { Navigate, useRoutes } from "react-router-dom";
import sportsRoutes from "../containers/Sports/route"; // your sports routes array import
import NotFound from "../components/NotFound";
import eventsRoutes from "@/containers/events-category/route";
import ridesRoutes from "@/containers/rides/route"; // Import rides routes
import { lazy, Suspense } from "react";
import SpinnerLoader from "@/components/SpinnerLoader";

const Loadable = (Component) => (props) =>
(
  <Suspense fallback={<SpinnerLoader />}>
    <Component {...props} />
  </Suspense>
);

// bookings
const MyBookings = Loadable(
  lazy(() => import("../components/bookings-status"))
);
const BookingCancel = Loadable(
  lazy(() => import("../components/booking-cancel"))
);
const ProviderDashboard = Loadable(
  lazy(() => import("../components/provider-dashboard"))
);
const SignIn = Loadable(
  lazy(() => import("../components/signIn"))
);
const SignUp = Loadable(
  lazy(() => import("../components/signUp"))
);
const OtpVerify = Loadable(
  lazy(() => import("@/components/otpVerify"))
);
const EventsMyTicket = Loadable(
  lazy(() => import("@/components/ticket-user/Tickets"))
);

const routes = [
  {
    path: "/",
    index: true,
    element: <Navigate to="/events" replace />,
  },
  {
    path: "/my-bookings",
    element: (
      <Suspense fallback={<SpinnerLoader />}>
        <MyBookings />
      </Suspense>
    ),
  },
  {
    path: "/cancel-booking",
    element: (
      <Suspense fallback={<SpinnerLoader />}>
        <BookingCancel />
      </Suspense>
    ),
  },
  {
    path: "/provider-dashboard/:provider_id",
    element: (
      <Suspense fallback={<SpinnerLoader />}>
        <ProviderDashboard />
      </Suspense>
    ),
  },
  {
    path: "/signin",
    element: (
      <Suspense fallback={<SpinnerLoader />}>
        <SignIn />
      </Suspense>
    ),
  },
  {
    path: "/signup",
    element: (
      <Suspense fallback={<SpinnerLoader />}>
        <SignUp />
      </Suspense>
    ),
  },
  {
    path: "/verify-otp",
    element: (
      <Suspense fallback={<SpinnerLoader />}>
        <OtpVerify />
      </Suspense>
    ),
  },
  ...sportsRoutes,
  ...eventsRoutes,
  ...ridesRoutes,
  {
    path: "/booking/ticket/*",
    element: (
      <Suspense fallback={<SpinnerLoader />}>
        <EventsMyTicket />
      </Suspense>
    ),
  },
  {
    path: "not-found",
    element: <NotFound />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default function AppRouter() {
  const element = useRoutes(routes);
  return element;
}
